module.exports = __webpack_public_path__ + "static/media/Vector 1.c9bf594b.png";